import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Immutable from 'immutable';
import clsx from 'clsx';
import config from 'config/api';
import { Link } from 'react-router-dom';
import { isLoggedIn, getCurrentUser } from 'ducks/authentication';
import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
// import Box from "@material-ui/core/Box";
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import i18n from 'helpers/i18n';
const styles = (theme) => {
  return {
    root: {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.tercary.light,
      padding: '20px 30px',
      '& .MuiTypography-body1': {
        color: theme.palette.primary.main,
      },
      '& .MuiListItemText-root': {
        // marginLeft: '-5px'
      },
    },
    footerWrapper: {
      textAlign: 'center',
    },
    list: {
      display: 'inline-block',
      width: 'auto',
      paddingTop: 0,
      paddingBottom: 0,
      margin: 0,
      padding: 0,
      // [theme.breakpoints.down("sm")]: {
      //   padding: "4px 5px"
      // }
    },
    listItem: {
      display: 'inline-block',
      width: 'auto',
      paddingTop: 0,
      paddingBottom: 0,
      margin: 0,
      padding: 0,
      // [theme.breakpoints.down("sm")]: {
      //   padding: "4px 5px"
      // }
    },
    separator: {
      float: 'right',
      width: 5,
      // marginLeft: '-5px',
      [theme.breakpoints.down('md')]: {
        // display: 'none'
      },
    },
    link: {
      padding: '0 10px',
      fontSize: '0.9rem',
      textDecoration: 'none',
      color: theme.palette.primary.main,
      borderBottom: '1px ' + theme.palette.primary.main + ' solid',
      transition: [
        theme.transitions.create('border-color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      ],
      '&:hover': {
        borderBottom: '1px ' + theme.palette.text.light + ' solid',
      },
      '&:visited': {
        color: theme.palette.primary.main,
      },
    },
    version: {
      fontSize: '0.8rem',
    },
    menu: {
      marginBottom: '10px',
    },
    text: {
      fontSize: '0.6rem',
    },
  };
};
class Footer extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {};
  // }
  // componentDidMount() {}
  // _openLink(e, link) {
  //   e.preventDefault();
  //   const conf = window.confirm("En cliquant sur ce lien, vous quittez le site.\n\nSi vous souhaitez poursuivre votre navigation sur ce site internet externe, cliquez sur Continuer.\nSobi n'est pas responsable des contenus présents sur ce site internet.");
  //   if(conf)
  //     window.open(link);
  // }
  render() {
    const { $$user, classes, colouredBackground, theme } = this.props;
    const $$menu = config.getMenu($$user, {
      asImmutable: true,
    });
    const textColor = colouredBackground
      ? {
          color: theme.palette.text.light,
          '&:visited': {
            color: theme.palette.text.light,
          },
        }
      : undefined;
    const menuSize = $$menu !== undefined ? $$menu.size : 0;
    return (
      <Grid item container alignItems="center" justify="center" align="center" className={classes.root}>
        <Grid item xs={12}>
          <List className={clsx(classes.list, classes.menu)}>
            {$$menu
              .map((m, mIdx) => {
                return (
                  <ListItem key={'fmn_' + mIdx} className={classes.listItem}>
                    <ListItemText>
                      <If condition={mIdx <= menuSize}>
                        <span className={classes.separator}>-</span>
                      </If>
                      <Link className={classes.link} style={textColor} to={m.get('url')}>
                        {m.get('title')}
                      </Link>
                    </ListItemText>
                  </ListItem>
                );
              })
              .toArray()}

            <ListItem className={classes.listItem}>
              <ListItemText>
                <span className={classes.separator}>-</span>
                <Link className={classes.link} style={textColor} to={'/confidentiality'}>
                  {i18n.get('footerConfidentiality', { pretty: false })}
                </Link>
              </ListItemText>
            </ListItem>
            <ListItem className={clsx(classes.listItem, classes.listItemLast)}>
              <ListItemText>
                <a
                  href="https://terms.gsk.com/fr-fr/pharmaceuticals/default/"
                  className={classes.link}
                  style={textColor}
                  target="_blank"
                >
                  {i18n.get('footerLegal', { pretty: false })}
                </a>
              </ListItemText>
            </ListItem>
          </List>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.text}>{i18n.get('footerText')}</Typography>
        </Grid>
      </Grid>
    );
  }
}
// export default Footer;
//
//
// export default withRouter(Header);
function mapStateToProps(state) {
  const props = {
    isLoggedIn: isLoggedIn(state),
    $$user: getCurrentUser(state),
  };
  return props;
}
export default withTheme(withStyles(styles)(connect(mapStateToProps)(Footer)));



// WEBPACK FOOTER //
// ./src/components/Footer.jsx